import lazySizes from "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import "./boxheight";

const lazy = $(document).ready(function () {
    /// lazysizes config
    window.lazySizesConfig = window.lazySizesConfig || {};
    lazySizesConfig.loadMode = 1;
    lazySizesConfig.preloadAfterLoad = true;
    lazySizesConfig.expand = 1500;
    lazySizesConfig.ricTimeout = 0;
    lazySizes.init();

    document.addEventListener("lazyloaded", function (e) {
        let thisTarget = $(e.target);
        let thisSpinner = $(thisTarget).closest(".spinner");
        if (thisSpinner) {
            if ($(thisSpinner).is(":visible")) {
                $(thisSpinner).fadeOut();
            }
        }
        $(".sameheight").css("height", "auto");
        $(".sameheight").boxheight();
    });
});

export { lazy as default };
